import { useDispatch, useSelector } from '@tabeeb/store'
import { Button, ConfirmationDialog, useDialogState } from '@collaborate-health/uikit'
import { completeInContentReviewRequest } from '@tabeeb/modules/contentReviews/actions'
import { getContentId } from '@tabeeb/modules/shared/content/selectors'

import { FormButtons } from '../../services/enums'
import { getFormButtonState } from '../../selectors'

const CompleteInContentReviewButton = () => {
  const dispatch = useDispatch()

  const [open, onOpen, onClose] = useDialogState()

  const { isVisible, isDisabled } = useSelector((state) =>
    getFormButtonState(state, { button: FormButtons.CompleteInContentReview })
  )
  const contentId = useSelector(getContentId)

  if (!isVisible) {
    return null
  }

  return (
    <>
      <Button variant='contained' color='primary' disabled={isDisabled} size='small' fullWidth onClick={onOpen}>
        Complete review
      </Button>

      <ConfirmationDialog
        isOpen={open}
        cancelButtonText='Close'
        submitButtonText='Complete'
        title='Once this review is complete, you will no longer be able to send feedback. Please confirm to complete this review'
        onCloseDialog={onClose}
        onSubmit={() => {
          dispatch(completeInContentReviewRequest({ contentId }))
          onClose()
        }}
      />
    </>
  )
}

export default CompleteInContentReviewButton

